import { render, staticRenderFns } from "./TagSelect.vue?vue&type=template&id=4f8cc79a&scoped=true&"
import script from "./TagSelect.vue?vue&type=script&lang=ts&"
export * from "./TagSelect.vue?vue&type=script&lang=ts&"
import style0 from "./TagSelect.vue?vue&type=style&index=0&id=4f8cc79a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8cc79a",
  null
  
)

export default component.exports